import { gql } from '@apollo/client';
import { TRANSLATED_STRING_FIELDS } from '@assets/i18n/config';

export const FETCH_BILLING_CYCLE_BREADCRUMB = gql`
  query fetchBillingCycleBreadcrumb($billingCycleId: ObjectID!) {
    fetchBillingCycle(billingCycleId: $billingCycleId) {
      billingCycle {
        organization { id translatedName { ${TRANSLATED_STRING_FIELDS} } }
        startDate
        endDate
      }
    }
  }
`;
